/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Directive, ElementRef, Input } from '@angular/core';

@Directive({
  standalone: false,
  selector: 'gh-message',
})
export class MessageDirective {
  @Input() key: string;

  constructor(private elementRef: ElementRef) {

  }

  get value(): string {
    return this.elementRef.nativeElement.textContent;
  }
}
